import clsx from 'clsx'

interface Props {
    onClick: () => void
}

/**
 * Liste ekranlarında araç çubuğunun başındaki "Yenile" düğmesi. Listeyi mevcut kolon
 * filtreleri, sıralama ve sayfayla yeniden yükler; hiçbir filtreyi silmez. Bu sürede
 * gelen ve kriterlere uyan yeni kayıtlar listeye düşer.
 */
const RefreshButton = ({ onClick }: Props) => {
    return (
        <div className='m-0'>
            <button
                type='button'
                onClick={onClick}
                title='Listeyi aynı filtrelerle yeniden yükle'
                className={clsx('btn btn-sm btn-flex fw-bold bg-gray-200 btn-color-gray-700 btn-active-color-primary btn-active-light-primary')}
            >
                <i className='fa fa-sync-alt fs-6 color-gray-700 me-1' />
                Yenile
            </button>
        </div>
    )
}

export default RefreshButton
